<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "CustomerList",
  data() {
    return {
      baseUrl: 'custom',
      breadcrumb: [
        { name: "运单管理" },
        { name: "运单列表" },
      ],
      menuIndex: `/cOrder/list/tobe`,
      menu: [
        {
          name: "待运送",
          path: `/cOrder/list/tobe`,
        },
        {
          name: "运送中",
          path: `/cOrder/list/ing`,
        },
        {
          name: "已送达",
          path: `/cOrder/list/done`,
        },
      ],
    };
  },
  computed: {},
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
<style lang="less" scoped></style>